export default __webpack_public_path__ + "static/media/mongolab.f0083873.svg";